import ParameterErrors from '../errors/ParameterErrors';
import Validation from '../validation/Validation';
const{throwNotProvided, throwNotOfType}=ParameterErrors;
export default class EulerAngles {
    constructor(props) {
		const {yawRadians, pitchRadians, rollRadians}=props;
		if(yawRadians===undefined||yawRadians===null)
			throwNotProvided('yawRadians');
		if(pitchRadians===undefined||pitchRadians===null)
			throwNotProvided('pitchRadians');
		if(rollRadians===undefined||rollRadians===null)
			throwNotProvided('rollRadians');
		this._yawRadians = yawRadians;
		this._pitchRadians = pitchRadians;
		this._rollRadians = rollRadians;
    }
    get yawRadians() {
        return this._yawRadians;
    }
    get pitchRadians() {
        return this._pitchRadians;
    }
    get rollRadians() {
        return this._rollRadians;
    }
    static fromJSON(obj) {
        return new EulerAngles(obj);
    }
}
